import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/Auth/Login.vue";
import { PENGAJUAN_KUITANSI_DIBUKA } from "../data/fitur";
import { catatHalaman } from "../utils/analytics";

const routes = [
  {
    // Dibuka dari ikon aplikasi (start_url "/"): langsung ke Beranda, tanpa ditahan layar
    // pembuka. Query ikut dibawa supaya parameter kampanye (utm_*) tetap terbaca GA4.
    path: "/",
    redirect: (to) => ({ path: "/home", query: to.query, hash: to.hash }),
  },
  {
    path: "/login",
    name: "login-view",
    meta: { judul: "Masuk atau Daftar" },
    component: LoginView,
  },
  {
    path: "/register",
    name: "register-view",
    meta: { judul: "Lengkapi Akun" },
    component: () => import("../views/Auth/Register.vue"),
  },
  {
    // Link masuk dari WhatsApp. Saat halaman dibuka langsung, utils/tokenMasuk.js sudah
    // memindahkan token dari URL sehingga yang tiba di sini /masuk tanpa parameter.
    path: "/masuk/:token?",
    name: "masuk-link",
    meta: { judul: "Masuk" },
    component: () => import("../views/Auth/MasukLink.vue"),
  },
  {
    path: "/referral/:code",
    name: "public-referral",
    meta: { judul: "Daftar Perawatan RUMAT", gaAlamatAsli: true },
    component: () => import("../views/PublicReferralForm.vue"),
  },
  {
    path: "/daftar-agent/:referralCode",
    name: "agent-register",
    meta: { judul: "Daftar Care Network Advisor", gaAlamatAsli: true },
    component: () => import("../views/Auth/AgentRegister.vue"),
  },
  {
    path: "/home",
    name: "HomeView",
    meta: { judul: "Beranda" },
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/appointment",
    name: "appointment",
    meta: { judul: "Buat Janji Unit" },
    component: () => import("../views/Appointment/Appointment.vue"),
  },
  {
    path: "/detail-appointment/:id",
    name: "detail-appointment",
    meta: { judul: "Detail Unit", gaAlamatAsli: true },
    component: () => import("../views/Appointment/Detail-Appointment.vue"),
  },
  {
    path: "/homecare",
    name: "homecare-view",
    meta: { judul: "Homecare" },
    component: () => import("../views/Homecare/Homecare.vue"),
  },
  {
    path: "/booking-homecare/:id",
    name: "booking-homecare",
    meta: { judul: "Selesaikan Pesanan" },
    component: () => import("../views/Homecare/Booking-Homecare.vue"),
  },
  {
    path: "/gds-tracker",
    name: "gds-view",
    meta: { judul: "GDS Tracker" },
    component: () => import("../views/GDS/Gds-Tracker.vue"),
  },
  {
    path: "/history-gds/:patientId",
    name: "history-gds",
    meta: { judul: "Riwayat GDS" },
    component: () => import("../views/GDS/History-GDS.vue"),
  },
  {
    path: "/riwayat-pemesanan",
    name: "history-view",
    meta: { judul: "Riwayat Pemesanan" },
    component: () => import("../views/History/Order-History.vue"),
  },
  {
    path: "/detail-pemesanan/:id",
    name: "order-detail",
    meta: { judul: "Detail Pemesanan" },
    component: () => import("../views/History/Order-Details.vue"),
  },
  {
    path: "/notifikasi",
    name: "notification-view",
    meta: { judul: "Notifikasi" },
    component: () => import("../views/Notification/Notification.vue"),
  },
  {
    path: "/profil",
    name: "profile-view",
    meta: { judul: "Profil Saya" },
    component: () => import("../views/Profile/ProfileView.vue"),
  },
  {
    path: "/pengaturan",
    name: "setting-view",
    meta: { judul: "Pengaturan Akun" },
    component: () => import("../views/Profile/Setting.vue"),
  },
  {
    path: "/support",
    name: "support-view",
    meta: { judul: "Pusat Bantuan" },
    component: () => import("../views/Profile/Support.vue"),
  },
  {
    path: "/faq",
    name: "faq-view",
    meta: { judul: "Paling Sering Ditanyakan" },
    component: () => import("../views/Profile/FAQ.vue"),
  },
  {
    path: "/customer-service",
    name: "cs-view",
    meta: { judul: "Layanan Bantuan Pengguna" },
    component: () => import("../views/Profile/ListCustomerService.vue"),
  },
  {
    path: "/riwayat-luka/:mr/:dob",
    name: "injury-view",
    meta: { judul: "Riwayat Perawatan" },
    component: () => import("../views/Profile/Injury-History.vue"),
  },
  {
    path: "/detail-luka",
    name: "detail-injury",
    meta: { judul: "Foto Luka" },
    component: () => import("../views/Profile/Detail-Injury.vue"),
  },
  {
    path: "/syarat-dan-ketentuan",
    name: "conditions-view",
    meta: { judul: "Syarat dan Ketentuan" },
    component: () => import("../views/Profile/Conditions.vue"),
  },
  {
    path: "/artikel",
    name: "article-view",
    meta: { judul: "Artikel" },
    component: () => import("../views/Article/Article.vue"),
  },

  {
    path: "/video",
    name: "video-view",
    meta: { judul: "Video" },
    component: () => import("../views/Video/VideoPage.vue"),
  },
  {
    path: "/detail-artikel/:slug",
    name: "detail-article",
    meta: { judul: "Artikel", gaAlamatAsli: true },
    props: true,
    component: () => import("../views/Article/Detail-Article.vue"),
  },
  {
    path: "/edukasi",
    name: "education-view",
    meta: { judul: "Berita Kesehatan" },
    component: () => import("../views/Education/Education.vue"),
  },
  {
    path: "/detail-edukasi/:slug",
    name: "detail-education",
    meta: { judul: "Berita Kesehatan", gaAlamatAsli: true },
    props: true,
    component: () => import("../views/Education/Detail-Education.vue"),
  },
  {
    path: "/buku-panduan",
    name: "buku-panduan",
    meta: { judul: "Buku Panduan" },
    component: () => import("../views/GuideBook/Guide-Book.vue"),
  },
  // Kuitansi digital pasien — lembar yang sama dengan yang dikirim perawat lewat
  // WhatsApp dari ROSY, tapi di sini tidak kedaluwarsa: pemiliknya sudah login.
  {
    path: "/kuitansi",
    name: "kuitansi-list",
    meta: { judul: "Riwayat Kuitansi" },
    component: () => import("../views/Kuitansi/Kuitansi-List.vue"),
  },
  {
    // Didaftarkan SEBELUM "/kuitansi/:token". Vue Router memang memenangkan ruas
    // statis atas parameter, tapi urutan berkas ini adalah tempat pertama orang
    // mencari saat rute terasa saling menimpa — jadi kedekatannya dijaga di sini,
    // bukan diserahkan ke aturan peringkat yang harus diingat.
    path: "/kuitansi/:token/ajukan",
    name: "kuitansi-pengajuan",
    meta: { judul: "Minta Kuitansi Resmi" },
    component: () => import("../views/Kuitansi/Kuitansi-Pengajuan.vue"),
    // Pintunya disembunyikan di layar kuitansi, tapi alamatnya tetap bisa
    // diketik, ditinggalkan di riwayat peramban, atau dibagikan. Penjagaan
    // ditaruh DI RUTENYA supaya tidak bergantung pada tombol mana yang
    // kebetulan masih terpasang.
    //
    // Dipulangkan ke lembar kuitansinya sendiri, bukan ke 404: pemakai yang
    // sampai ke sini memang sedang melihat kuitansi itu, dan halaman galat
    // untuk alamat yang kemarin masih hidup terbaca seperti aplikasi rusak.
    beforeEnter(to, from, next) {
      if (PENGAJUAN_KUITANSI_DIBUKA) return next();
      return next({ name: "kuitansi-detail", params: { token: to.params.token } });
    },
  },
  {
    // Dikenali lewat TOKEN, bukan nomor urut baris. Nomor urut di URL adalah
    // undangan untuk mencoba nomor sebelah, dan kuitansi memuat nama, unit, serta
    // rincian biaya seseorang.
    path: "/kuitansi/:token",
    name: "kuitansi-detail",
    meta: { judul: "Kuitansi" },
    component: () => import("../views/Kuitansi/Kuitansi-Detail.vue"),
  },
  {
    // Didaftarkan sebelum "/permohonan-kuitansi/:id" supaya ruas statisnya menang
    // tanpa bergantung pada aturan peringkat.
    path: "/permohonan-kuitansi",
    name: "kuitansi-daftar-permohonan",
    meta: { judul: "Permohonan Saya" },
    component: () => import("../views/Kuitansi/Kuitansi-DaftarPermohonan.vue"),
  },
  {
    // Berdiri di luar "/kuitansi/..." karena satu permohonan bisa hidup lebih lama
    // daripada kunjungan pasien ke lembar kuitansinya, dan nomor permohonan inilah
    // yang ia sebutkan saat menelepon CS.
    path: "/permohonan-kuitansi/:id",
    name: "kuitansi-permohonan",
    meta: { judul: "Permohonan Kuitansi Resmi" },
    component: () => import("../views/Kuitansi/Kuitansi-Permohonan.vue"),
  },
  {
    path: "/buku-panduan/:slug",
    name: "panduan-bab",
    meta: { judul: "Buku Panduan", gaAlamatAsli: true },
    component: () => import("../views/GuideBook/PanduanBab.vue"),
  },
  {
    path: "/ricka-pasien",
    name: "ricka-pasien",
    meta: { judul: "Skor Ricka Pasien" },
    component: () => import("../views/Ricka/Ricka-View.vue"),
  },
  {
    path: "/edukasi-ricka",
    name: "edu-ricka-view",
    meta: { judul: "Edukasi Seputar Ricka" },
    component: () => import("../views/Ricka/EdukasiRicka.vue"),
  },
  {
    path: "/edit-pasien/:id/:bool?",
    name: "edit-pasien",
    meta: { judul: "Edit Data Pasien" },
    component: () => import("../views/Profile/EditPasien.vue"),
  },

  {
    path: "/tambah-alamat-user",
    name: "tambah-alamat-user",
    meta: { judul: "Tambah Alamat" },
    component: () => import("../views/Profile/UserAlamat/AddAlamat.vue"),
  },

  {
    path: "/edit-alamat-user/:id",
    name: "edit-alamat-user",
    meta: { judul: "Ubah Alamat" },
    component: () => import("../views/Profile/UserAlamat/EditAlamat.vue"),
  },

  // Form "Pendaftaran Perawatan Luka Kalus" (Agustus 2025) sudah dicabut: endpoint-nya publik
  // dan menulis ke data pasien. Tautan lama yang masih beredar diarahkan ke Beranda.
  {
    path: "/pendaftaran-perawatan-luka-kalus",
    redirect: "/home",
  },

  {
    path: "/daftar-alamat",
    name: "daftar-alamat",
    meta: { judul: "Daftar Alamat" },
    component: () => import("../views/Profile/Address/UserAddress.vue"),
  },
  {
    path: "/portal-agent",
    name: "agent-dashboard",
    meta: { judul: "Portal Rumat Care Network" },
    component: () => import("../views/Agent/AgentDashboard.vue"),
  },
  {
    path: "/portal-agent/referrals",
    name: "agent-referrals",
    meta: { judul: "Riwayat Referral" },
    component: () => import("../views/Agent/AgentReferrals.vue"),
  },
  {
    path: "/portal-agent/voucher-k5",
    name: "agent-k5",
    meta: { judul: "Voucher K-5" },
    component: () => import("../views/Agent/AgentVoucherK5.vue"),
  },
  {
    path: "/portal-agent/referrals/baru",
    name: "agent-referral-form",
    meta: { judul: "Daftarkan Pasien" },
    component: () => import("../views/Agent/AgentReferralForm.vue"),
  },
  {
    path: "/portal-agent/wallet",
    name: "agent-wallet",
    meta: { judul: "Riwayat Komisi" },
    component: () => import("../views/Agent/AgentWallet.vue"),
  },
  {
    path: "/portal-agent/withdrawals",
    name: "agent-withdrawals",
    meta: { judul: "Penarikan" },
    component: () => import("../views/Agent/AgentWithdrawals.vue"),
  },
  {
    path: "/portal-agent/withdrawals/baru",
    name: "agent-withdrawal-request",
    meta: { judul: "Ajukan Penarikan" },
    component: () => import("../views/Agent/AgentWithdrawalRequest.vue"),
  },
  {
    path: "/portal-agent/about",
    name: "agent-about",
    meta: { judul: "Tentang Care Network" },
    component: () => import("../views/Agent/AgentAbout.vue"),
  },
  {
    path: "/portal-agent/bagikan",
    name: "agent-share-link",
    meta: { judul: "Bagikan Link Referral" },
    component: () => import("../views/Agent/AgentShareLink.vue"),
  },
  {
    path: "/portal-agent/requests",
    name: "agent-manager-requests",
    meta: { judul: "Care Network Saya" },
    component: () => import("../views/Agent/AgentManagerRequests.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Judul tab + page_view GA4. Alamat yang dikirim ke GA4 disamarkan untuk rute yang
// menunjuk data pasien — lihat alamatHalaman() di utils/analytics.js.
router.afterEach((to, from, failure) => {
  if (failure) return;
  document.title = to.meta.judul ? `${to.meta.judul} · RUMATKITA` : "RUMATKITA";
  catatHalaman(to, from);
});

export default router;
